/* import __COLOCATED_TEMPLATE__ from './selected-term-tree.hbs.js'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import { TrackedAsyncData } from 'ember-async-data';
import { cached } from '@glimmer/tracking';
let DashboardSelectedTermTreeComponent = (_class = class DashboardSelectedTermTreeComponent extends Component {
  get childrenData() {
    return new TrackedAsyncData(this.args.term.children);
  }
  get children() {
    return this.childrenData.isResolved ? this.childrenData.value : [];
  }
  get level() {
    return this.args.level ?? 0;
  }
}, _applyDecoratedDescriptor(_class.prototype, "childrenData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "childrenData"), _class.prototype), _class);
export { DashboardSelectedTermTreeComponent as default };